import { createGlobalStyle } from 'styled-components';
import { getScrollBarStyles } from '@toqio/toqio-web-components';

// Paint our own background — react-native-webview hosts mount us with a
// transparent canvas, so without this the RN screen color bleeds through.
export const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body {
    margin: 0;
    background: ${({ theme }) => theme.colors.general_background};
    font-family: ${({ theme }) =>
      String(theme.colors.font_family ?? 'system-ui, -apple-system, "Segoe UI", sans-serif')};
  }

  /* Thin, theme-coloured scrollbar (transparent track → shows the page bg),
     so the embedded iframe matches the host instead of showing the chunky
     default OS scrollbar. Mirrors lum-web's globalStyles. */
  ${getScrollBarStyles}
  ::-webkit-scrollbar-thumb {
    min-height: 40px;
  }
`;
